
import { Component, Prop, Vue } from "vue-property-decorator";
import { SearchResult } from "zaehlerfreunde-proto-types/tariff_pb";

@Component
export default class Certificates extends Vue {
  @Prop({ default: () => [] }) certificates: SearchResult.Certificate[];
}
